export default {
  set: ( name:string, value: any ) => localStorage.setItem( name, value ),
  get: ( name: string ) => localStorage.getItem( name ),
  clear: ( name: string ) => localStorage.removeItem( name ),
};
